// extracted by mini-css-extract-plugin
export default {"hideTooltip":"S9-z","fadeIn":"T9-z","delay":"U9-z","recommendedSizeTooltip":"V9-z"};